module.exports = require("./src/xlsx-stream-writer");
